<!--
 * @Author: zhangzibo
 * @Date: 2021-07-24 16:39:39
 * @Description: 视频专辑
-->
<template>
  <div class="album">
    <tip></tip>
    <template v-if="videoObj.enable">
      <empty></empty>
    </template>
    <template v-else>
      <div class="conntent">
        <div class="big-img">
          <img :src="videoObj.pic" alt="">
          <span class="zhuanjie">专辑</span>
        </div>
<!--        <div class="title-wrapper">-->
<!--          <h3 class="title" v-if="videoObj.name">{{videoObj.name.slice(0,15)}}</h3>-->
<!--          <div class="round-div">图片</div>-->
<!--        </div>-->
        <!--      <h3 class="title" v-if="videoObj.name" @click="topage">{{videoObj.name.slice(0,15)}}</h3>-->
<!--        <div class="author_info">-->
<!--        <span class="span_info">-->
<!--          <span class="span-img"><img :src="videoObj.user_avatar" alt=""></span>-->
<!--          <span class="auther" v-if="videoObj.user_name">{{videoObj.user_name.slice(0,15)}}</span>-->
<!--        </span>-->
<!--        </div>-->
<!--        <div class="synopsis">-->
<!--          <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{videoObj.description}}</p>-->
<!--          <span @click="zhankaiFn" v-if="videoObj.description && videoObj.description.length > 48">-->
<!--          <img v-if="!iszhankai" src="../../assets/img/zhankan.png" alt="">-->
<!--          <img v-if="iszhankai" src="../../assets/img/shouqi.png" alt="">-->
<!--        </span>-->
<!--        </div>-->
      </div>
      <div class="videoList-box" v-if="videoObj && videoObj.name">
        <div class="text-content">
          <div class="title" @click="topage">
          <span class="hs-title">
            {{ videoObj.name.slice(0,15) }}
          </span>
            <span class="zhuanji">图片</span>
          </div>
          <div class="header-img">
            <img :src="videoObj.user_avatar" alt="">
            <div class="header-title" v-if="videoObj.user_name">{{ videoObj.user_name.slice(0,15) }}</div>
            <div class="buylink" v-if="videoObj.buy_link" @click="toBuy(videoObj.buy_link)">
              购买此书
            </div>
          </div>
          <div class="synopsis">
            <p class="synopsis-text" :class="{ zhankai: !iszhankai }">简介：{{videoObj.description}}</p>
            <span @click="zhankaiFn" v-if="videoObj.description && videoObj.description.length > 48">
            <img v-if="!iszhankai" src="../../assets/img/zhankan.png" alt="">
            <img v-if="iszhankai" src="../../assets/img/shouqi.png" alt="">
          </span>
          </div>
        </div>
        <div class="videoList">
          <h3 class="video_count">共{{videoList.length || 0}}张图片</h3>
          <template v-if="videoList.length">
            <div v-for="(group, groupIndex) in groupedVideoList" :key="groupIndex">
              <div class="segmen_name">
                <span>{{group.startIndex}}-{{group.endIndex}}</span>
              </div>
              <div class="item-box">
                <div class="item-list" v-for="(item, index) in group.items" :key="group.groupIndex * 10 + index" @click="topageDetail(group.groupIndex * 10 + index)">
                  <div class="cover_pic" >
                    <img :src="item.pic" alt="">
                    <div v-if="!canView" class="pass">
                      <img src="../../assets/img/lock.png" style="width: 32px; height: 32px;">

<!--                      <svg t="1741188517717" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8049" width="32" height="32"><path d="M787.16806 952.268282 236.83194 952.268282c-30.395264 0-55.033407-24.638143-55.033407-55.033407L181.798533 429.449889c0-30.395264 24.638143-55.033407 55.033407-55.033407l82.550111 0 0-110.066815c0-106.379842 86.238107-192.617949 192.617949-192.617949s192.617949 86.238107 192.617949 192.617949l0 110.066815 82.550111 0c30.395264 0 55.033407 24.638143 55.033407 55.033407l0 467.784986C842.201467 927.630139 817.562301 952.268282 787.16806 952.268282zM484.483296 672.046113l0 115.121947 55.033407 0 0-115.121947c31.990598-11.373025 55.033407-41.605583 55.033407-77.496002 0-45.592384-36.957727-82.550111-82.550111-82.550111s-82.550111 36.957727-82.550111 82.550111C429.449889 630.440529 452.491675 660.673088 484.483296 672.046113zM622.066815 264.348644c0-60.787458-49.279357-110.066815-110.066815-110.066815s-110.066815 49.279357-110.066815 110.066815l0 110.066815 220.134653 0L622.067838 264.348644z" fill="#ffffff" p-id="8050"></path></svg>-->
<!--                    -->
                    </div>
                  </div>
                  <div class="item-name">{{item.title||group.groupIndex * 10 + index + 1}}</div>
                </div>
                <div class="width20"></div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="xiajia">
              该专辑下无内容
            </div>
          </template>
        </div>
      </div>
    </template>
    <Dialog
        :visible="showDialog"
        title="请输入密码"
        @close="showDialog = false"
        @cancel="showDialog = false"
        @confirm="handleConfirm"
    />

  </div>
</template>

<script>
import tip from '@/components/tip.vue';
import empty from '@/components/empty.vue'
import {Indicator, Toast} from 'mint-ui';
import wechat from "@/plugins/wx";
import Dialog from "@/components/dialog.vue";
export default {
  components: {
    Dialog,
    tip,
    empty,
  },
  data() {
    return {
      videoObj: {},
      videoList: [],
      id: 0,
      iszhankai: false,
      shareConfig: {
        title: '分享标题',
        desc: '这是一个测试的微信分享',
        link: '', // 分享链接
        imgUrl: '', // 分享图标
      },
      canView:false,
      showDialog:false,
    }
  },
  computed: {
    // 将videoList按10个一组进行分组
    groupedVideoList() {
      if (!this.videoList || this.videoList.length === 0) {
        return [];
      }
      
      const groups = [];
      const chunkSize = 10;
      
      for (let i = 0; i < this.videoList.length; i += chunkSize) {
        const group = this.videoList.slice(i, i + chunkSize);
        const startIndex = i + 1;
        const endIndex = Math.min(i + chunkSize, this.videoList.length);
        
        groups.push({
          items: group,
          startIndex: startIndex,
          endIndex: endIndex,
          groupIndex: Math.floor(i / chunkSize)
        });
      }
      
      return groups;
    }
  },
  created () {
    this.id = this.$route.query.id || 1
    this.getVideoList()
    this.report(this.id,10)
    //this.report("5",5)
  },
  methods: {
    handleConfirm(value) {
      if(value==this.videoObj.view_pass){
        localStorage.setItem(`gallery-auth-${this.id}`, value);
        this.showDialog = false
        this.canView = true;
      }else{
        Toast({
          message:'密码不对！',
        });
      }

    },
    async report(id,dt) {
      try {
        // 发送点击事件请求到服务端
        await this.$report.sendReport({
          "id": id,
          "dt":dt
        });

      } catch (error) {
        console.error("Error sending click request:", error);
      }
    },
    topage(){
      this.$router.push(`/videoList?id=${this.id}`)
    },
    toBuy(link){
      window.open(link, '_blank');
    },
    topageDetail(index){
      if(!this.canView){
        this.showDialog = true;
        return;
      }
      this.$router.push(`/galleryImg?id=${this.id}&start=${index}`)
    },
    zhankaiFn(){
      this.iszhankai = !this.iszhankai
    },
    async getVideoList() {
      try {
        Indicator.open()
        this.id = this.$route.query.id || 1
        const res = await this.axios.get(`https://api.ayerdudu.com/v1/gallery/${this.id}`)
        this.videoObj = res.data.data;
        const currentUrl = window.location.href.split('#')[0];
        this.shareConfig.title = this.videoObj.name;
        this.shareConfig.desc = this.videoObj.description;
        this.shareConfig.link = currentUrl;
        this.shareConfig.imgUrl = this.videoObj.pic;
        console.log('分享配置',this.shareConfig);
        this.canView = this.$checkViewPass("gallery-auth-"+this.id,this.videoObj.view_pass);
        //const currentUrl = 'http://videos.ayerdudu.com/audioDetail?id=d1b469a1-91f4-1400-d29e-241571036c3c';
        wechat.initConfig(currentUrl).then(() => {
          // 配置分享内容
          wechat.setShareOptions(this.shareConfig);
        });
        const res2 = await this.axios.get(`https://api.ayerdudu.com/v1/galleryImg/list?gid=${this.id}&sort=asc`)
        res2.data.data.forEach((item) => {
          if(!item.enable){
            this.videoList.push(item);
          }
        })

        console.log('结果',this.videoList);
        Indicator.close()
      } catch (err) {
        Indicator.close()
        console.log(err)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.album{
  width: 100%;
  min-height: 100%;
  //overflow: hidden;
  //overflow-y: scroll;
  background: #f6f6f6;
  &::-webkit-scrollbar {
    display: none;
  }
  .conntent{
    height: 100%;
    background: #fff;
    padding-bottom: 28px;
    padding-top: 28px;
    .big-img{
      width: 363px;
      height: 363px;
      margin: 0 auto 28px;
      position: relative;
      overflow: hidden;
      border-radius: 20px;
      // border: 1px solid #eee;
      box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // webkit-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // moz-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      // o-box-shadow:0px 1px 4px rgba(0,0,0,0.3),0 0 40px rgba(0,0,0,0.1) inset;
      img{
        width: 100%;
        height: 100%;
      }
      .zhuanjie{
        position: absolute;
        top: -57px;
        right: -53px;
        background: #22b07d;
        color: #fff;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        line-height: 174px;
        font-size: 24px;
        text-indent: 10px;
      }
    }
    .title-wrapper {
      display: flex;
      align-items: center; // 确保 h3 和 div 垂直居中
      justify-content: center; // 水平居中
      position: relative; // 相对定位
    }
    .round-div {
      width: 54px; // 设置宽度
      height: 32px; // 设置高度
      background-color: #22b07d; // 背景颜色
      border-radius: 6px; // 圆角
      margin-left: 12px; // 与 h3 的间距
      font-size: 18px;
      color: #fff;
      text-align: center;
      display: flex;
      justify-content: center; /* 水平居中 */
      align-items: center; /* 垂直居中 */
    }
    .title{
      line-height: 54px;
      font-size: 36px;
      text-align: center;
      //padding: 0 40px;
      font-weight: bold;
    }
    .author_info{
      height: 46px;
      overflow: hidden;
      position: relative;
      margin: 25px 0 20px 0;
      .span_info{
        display: inline-block;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .span-img{
        float: left;
        width: 46px;
        height: 46px;
        img{
          width: 100%;
          height: 100%;
          border-radius: 50%;
          box-shadow: 1px solid #bfbfbf;
        }
        margin-right: 12px;
      }
      .auther{
        float: left;
        height: 46px;
        font-size: 26px;
        line-height: 55px;
      }
    }
  }
  //.synopsis{
  //  font-size: 24px;
  //  color: #888;
  //  line-height: 36px;
  //  display: flex;
  //  padding: 0 38px;
  //  .synopsis-text{
  //    flex: 1;
  //    line-height: 37px;
  //    &.zhankai{
  //      text-overflow: -o-ellipsis-lastline;
  //      overflow: hidden;
  //      text-overflow: ellipsis;
  //      display: -webkit-box;
  //      -webkit-line-clamp: 2;
  //      line-clamp: 2;
  //      -webkit-box-orient: vertical;
  //    }
  //  }
  //  >span{
  //    width: 20px;
  //    position: relative;
  //    cursor: pointer;
  //    >img{
  //      width: 30px;
  //      height: 30px;
  //      position: absolute;
  //      bottom: 0;
  //    }
  //  }
  //}
  .item-box{
    margin-top: 28px;
    height: 270px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow-x: scroll;
    margin-bottom: 38px;
    &::-webkit-scrollbar {
      display: none;
    }
    .width20{
      display: inline-block;
      height: 268px;
      width: 40px;
      vertical-align: top; // 此处新增
    }
    .item-list{
      display: inline-block;
      height: 268px;
      width: 254px;
      overflow: hidden;
      border-radius: 10px;
      margin-right: 24px;
      background: #fff;
      position: relative;
      vertical-align: top; // 此处新增
      .min{
        position: absolute;
        display: inline-block;
        top: 120px;
        right: 11px;
        font-size: 24px;
        background: rgba(0, 0, 0, .3);
        border-radius: 14px;
        color: #fff;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        vertical-align: middle; // 此处新增
      }
      .cover_pic{
        display: block;
        width: 100%;
        height: 160px;
        position: relative;
        overflow: hidden;
        box-shadow: 1px solid #bfbfbf;
        .pass{
          position: absolute;
          /* 以下两行实现垂直水平居中 */
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%); /* 关键：基于自身尺寸偏移 */

          /* 以下为容器样式 */
          //background: rgba(0, 0, 0, .3);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          padding: 12px; /* 如果有需要可以保留 */

          /* 新增以下代码让 SVG 居中 */
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            width: 100%;
            height: 100%;
          }
        }
        img{
          width: 100%;
          //height: 100%;
        }
      }
      .name{
        font-size: 26px;
      }
      .item-name{
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        padding: 17px 17px 20px;
        height: 85px;
        font-size: 25px;
        line-height: 36px;
        white-space: normal;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        vertical-align: top; // 此处新增
      }
      .mengceng{
        display: none;
      }
      &.active{
        .item-name{
          color: #f6451b;
        }
        .mengceng{
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
          background:rgba(0, 0, 0, 0.25);
        }
      }
    }

  }
}
.videoList-box{
  background: #fff;
}
.videoList{
  padding-left: 36px;
  background: #f6f6f6;
  padding-bottom: 40px;
  border-radius: 30px 30px 0 0;
  .video_count{
    font-size: 32px;
    font-weight: bold;
    height: 110px;
    line-height: 130px;
  }
  .segmen_name{
    display: inline-flex;
    align-items: center;
    height: 48px;
    font-size: 26px;
    font-weight: bold;
    background: #fff;
    padding: 0 25px 0 17px;
    border-radius: 10px;
    position: relative;
    
    > span {
      display: inline-block;
      line-height: 1;
    }
    
    &::before{
      content: '';
      display: block;
      width: 6px;
      height: 24px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: #f6451b;
      border-radius: 3px;
    }
  }
}
.xiajia{
  font-size: 26px;
  text-align: center;
  line-height: 50px;
}
.title{
  height: 115px;
  .hs-title{
    display: block;
    font-size: 36px;
    float: left;
    line-height: 115px;
    font-weight: bold;
  }
  .zhuanji{
    float: left;
    margin-left: 10px;
    font-size: 20px;
    background: #22b07d;
    height: 36px;
    color: #fff;
    padding: 0 8px;
    border-radius: 5px;
    line-height: 37px;
    margin-top: 36px;
    transform: scale(0.8);
  }
}
.header-img{
  width: 100%;
  height: 64px;
  display: flex;
  margin-bottom: 22px;
  img{
    width: 64px;
    height: 64px;
    margin-right: 18px;
    border-radius: 50%;
    box-shadow: 1px solid #bfbfbf;
  }
  .header-title{
    flex: 1;
    line-height: 64px;
    font-size: 26px;
    color: #202020;
  }
  .buylink{
    float: right;
    //background-image: linear-gradient(to right, #fe7450 , #f6451b);
    padding: 19px 28px;
    border-radius: 40px;
    color: #f6451b;
    border-color: #f6451b;
    font-size: 24px;
    border: 2px solid #f6451b;
    margin-right: 30px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;     /* 垂直居中 */
  }
}
.text-content{
  box-sizing: border-box;
  width: 100%;
  padding: 0 38px;
  background: #fff;
}
.synopsis{
  font-size: 24px;
  color: #888;
  display: flex;
  padding-bottom: 28px;

  .synopsis-text{
    flex: 1;
    line-height: 37px;
    &.zhankai{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  >span{
    width: 20px;
    position: relative;
    cursor: pointer;
    >img{
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: 0;
    }
  }
}
</style>